export default __webpack_public_path__ + "static/media/WorkExperience.cec0d735.pdf";